import { render, staticRenderFns } from "./T1Kontakt.vue?vue&type=template&id=504c6ea2&scoped=true&"
import script from "./T1Kontakt.vue?vue&type=script&lang=js&"
export * from "./T1Kontakt.vue?vue&type=script&lang=js&"
import style0 from "./T1Kontakt.vue?vue&type=style&index=0&id=504c6ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c6ea2",
  null
  
)

export default component.exports